import commonService from "./CommonService";
import httpService from "./http";

const SysServices = {
  common: commonService,
  http: httpService,
};

export default SysServices;
